import {formatNumber} from './FormatNumber';

export function formatEnergy(energy: number, options: { withUnit: boolean } = { withUnit: true }) {
    return (formatNumber((Math.round(Math.trunc(energy) / 1000 * 100) / 100), 2) + (options.withUnit ? ' kWh' : ''));
}

export function formatPower(power: number, decimalsCount?: number): string {
    return formatNumber((Math.trunc(power) / 1000), decimalsCount) + ' kW';
}
